import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { authorableContentReducer } from './authorable-content/authorable-content';
import { dataBootStrapReducer } from './components/data-bootstrap/data-bootstrap';
import { vantageReducer } from './views/vantage/vantage';
import { ssmHomePageReducer } from './views/ssm-homepage/ssm-homepage';
import { ffwdHomePageReducer } from './views/ffwd-homepage/ffwd-homepage';
import { ngmHomePageReducer } from './views/ngm-homepage/ngm-homepage';
import { amsHomePageReducer } from './views/ams-homepage/ams-homepage';
import { amcHomePageReducer } from './views/amc-homepage/amc-homepage';
import { ampHomePageReducer } from './views/amp-homepage/amp-homepage';
import { sctHomePageReducer } from './views/sct-homepage/sct-homepage';
import { hostedMigrationReducer } from './views/hosted-migration/hosted-migration';
import { businessPopMailReducer } from './views/business-pop-mail/business-pop-mail';
import { marketComparisonReducer } from './views/market-comparison/market-comparison';
import { homePageReducer } from './views/homepage/homepage';
import { adaptiveMobilityExternalReducer } from './views/adaptive-mobility-external/adaptive-mobility-external';

const sharedReducers = {
  routing: routerReducer,
  authorableContentReducer,
  dataBootStrapReducer,
};

export const UnauthenticatedReducer = combineReducers({
  ...sharedReducers,
  vantageReducer,
  hostedMigrationReducer,
  businessPopMailReducer,
  adaptiveMobilityExternalReducer,
});

export const SSMApplicationReducer = combineReducers({
  ...sharedReducers,
  ssmHomePageReducer,
  marketComparisonReducer,
  homePageReducer,
  ffwdHomePageReducer,
  ngmHomePageReducer,
  amsHomePageReducer,
  amcHomePageReducer,
  ampHomePageReducer,
  sctHomePageReducer,
});

